import { useState } from 'react'
import { IAdvancedFilterArgs } from './AdvancedFilters.types'
import { AccordionWithCheckboxes } from '../Accordion/AccordionWithCheckboxes/AccordionWithCheckboxes'
import { getAccordionProps } from './AdvancedFilters.helpers'
import useId from '../../hooks/useId'

export const AdvancedFilters = ({
  onChange = () => {},
  filters = {},
  'data-testid': testid = 'filters'
}: IAdvancedFilterArgs) => {
  const { getTestId } = useId(testid)
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    false
  )

  // handle what happens when an accordion is pressed
  const handleAccordionValueChange =
    (filterName: string) => (checkboxName: string, checked: boolean) => {
      onChange({
        data: {
          filterName,
          checkboxName,
          checked
        }
      })
    }
  const handleAccordionClick = ({ panel }: { panel: string }) => {
    setExpandedAccordion(expandedAccordion === panel ? false : panel)
  }

  return (
    <>
      {Object.entries(filters).map(([filterKey, filterData]) => {
        const { type, title, options, uid, disabled } = filterData
        switch (type) {
          case 'checkbox':
          default:
            return (
              Object.keys(options).length !== 0 && (
                <AccordionWithCheckboxes
                  onOptionToggle={handleAccordionValueChange(filterKey)}
                  options={options}
                  disabled={disabled}
                  data-testid={getTestId(filterKey)}
                  {...getAccordionProps(
                    { uid, title },
                    expandedAccordion,
                    handleAccordionClick
                  )}
                />
              )
            )
        }
      })}
    </>
  )
}
